import { Fragment, useEffect, useRef } from 'react';
import styles from './Confusion.module.css';

const labelMap = {
  TP: 'True Spam',
  TN: 'True Non-Spam',
  FP: 'False Spam',
  FN: 'False Non-Spam',
};

export default function Confusion({ 
  dashboardData, 
  modelList, 
  testSetList, 
  checkedModels, 
  checkedTests 
}){
  const cellGridRef=useRef(null);
  const getModelName = (id) => modelList.find((m) => m.modelId === id)?.displayName || id;
  const getDatasetName = (id) => testSetList.find((d) => d.datasetId === id)?.datasetName || id;

  const getConfusionById = (modelId, datasetId) => {
    return dashboardData.find(
      (d) => d.modelId === modelId && d.datasetId === datasetId
    )?.result?.confusionDetail;
  };

  const modelIds = checkedModels;
  const datasetIds = checkedTests;

  useEffect(()=>{
    const el = cellGridRef.current;
    if(!el)return;

    const handleWheel = (e)=>{
      if(e.deltaY !==0){
        e.preventDefault();
        el.scrollLeft+=e.deltaY;
      }
    }
    el.addEventListener('wheel',handleWheel,{passive:false});
    return()=>el.removeEventListener('wheel',handleWheel);

  },[])

  return (
    <div className={styles.wrap}>
      <header>
        <span>Confusion Matrix</span>
        <div className={styles.legend}>
          <span>0%</span>
          <div className={styles.legendBar}></div>
          <span>100%</span>
        </div>
      </header>
      <div
        className={styles.grid}
        ref={cellGridRef}
        style={{
          gridTemplateColumns: `100px repeat(${modelIds.length}, 220px)`,
          gridTemplateRows: `30px repeat(${datasetIds.length}, 220px)`,
        }}
      >
        <div className={styles.cornerCell}></div>

        {modelIds.map((modelId) => (
          <div key={modelId} className={styles.colHeader}>
            {getModelName(modelId)}
          </div>
        ))}

        {datasetIds.map((datasetId, rowIdx) => (
          <Fragment key={datasetId}>
            <div className={styles.rowHeader}>
              {getDatasetName(datasetId)}
            </div>

            {modelIds.map((modelId, colIdx) => {
              const values = getConfusionById(modelId, datasetId);
              const total = values
                ? Object.values(values).reduce((sum, v) => sum + v, 0)
                : 0;

              const getOpacity = (count) => {
                const ratio = total > 0 ? count / total : 0;
                return `rgba(0, 123, 255, ${ratio})`;
              };

              return (
                <div
                  key={`${datasetId}-${modelId}`}
                  className={styles.cellGrid}
                  style={{
                    animationDelay: `${rowIdx * 0.1 + colIdx * 0.05}s`,
                  }}
                >
                  {['TP', 'FP', 'FN', 'TN'].map((key) => {
                    const count = values?.[key] ?? 0;
                    const percent = total > 0 ? ((count / total) * 100).toFixed(1) : '0.0';
                    return (
                      <div
                        key={key}
                        className={styles.cellBox}
                        style={{ backgroundColor: getOpacity(count) }}
                      >
                        {/* <div className={styles.tooltip}>
                          <strong>{labelMap[key]}</strong><br />
                          {count}개 ({percent}%)
                        </div> */}
                        <div className={styles.cellLabel}>{labelMap[key]}</div>
                        <div className={styles.cellValue}>{count} ({percent}%)</div>
                      </div>
                    );
                  })}
                </div>
              );
            })}
          </Fragment>
        ))}
      </div>
    </div>
  );
};
